import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import AOS from 'aos';
import 'aos/dist/aos.css';

// Import your images
import kabiniLogo from '../assets/images/kabini logo.jpg';
import gingerImg from '../assets/images/ginger.jpg';
import thymeImg from '../assets/images/thyme.webp';
import patternImg from '../assets/images/pattern1.png';

const VegetablesPage = () => {
  const [activeFilter, setActiveFilter] = useState('all');

  useEffect(() => {
    // Initialize AOS
    AOS.init({
      duration: 800,
      once: true,
      mirror: false,
      offset: 40,
      easing: 'ease-out-quad'
    });

    // Preloader hide after page load
    const preloader = document.querySelector('.preloader');
    if (preloader) {
      setTimeout(() => {
        preloader.style.opacity = '0';
        preloader.style.visibility = 'hidden';
      }, 500);
    }

    // Cleanup function
    return () => {
      // Cleanup if needed
    };
  }, []);

  // Filter vegetables
  const filterVegetables = (category) => {
    setActiveFilter(category);
  };

  // Social Icons SVG Sprites
  const socialIcons = (
    <svg style={{ display: 'none' }}>
      <symbol id="facebook" viewBox="0 0 24 24">
        <path d="M9.101 23.691v-7.98H6.627v-3.667h2.474v-1.58c0-4.085 1.848-5.978 5.858-5.978.401 0 .955.042 1.468.103a8.68 8.68 0 0 1 1.141.195v3.325a8.623 8.623 0 0 0-.653-.036 26.805 26.805 0 0 0-.733-.009c-.707 0-1.259.096-1.675.309a1.686 1.686 0 0 0-.679.622c-.258.42-.374.995-.374 1.752v1.297h3.919l-.386 2.103-.287 1.564h-3.246v8.245C19.396 23.238 24 18.179 24 12.044c0-6.627-5.373-12-12-12s-12 5.373-12 12c0 5.628 3.874 10.35 9.101 11.647Z"/>
      </symbol>
      <symbol id="twitter" viewBox="0 0 24 24">
        <path d="M23.953 4.57a10 10 0 0 1-2.825.775 4.958 4.958 0 0 0 2.163-2.723c-.951.555-2.005.959-3.127 1.184a4.92 4.92 0 0 0-8.384 4.482C7.69 8.095 4.067 6.13 1.64 3.162a4.822 4.822 0 0 0-.666 2.475c0 1.71.87 3.213 2.188 4.096a4.904 4.904 0 0 1-2.228-.616v.06a4.923 4.923 0 0 0 3.946 4.827 4.996 4.996 0 0 1-2.212.085 4.937 4.937 0 0 0 4.604 3.417 9.868 9.868 0 0 1-6.102 2.104c-.39 0-.779-.023-1.17-.067a13.995 13.995 0 0 0 7.557 2.209c9.054 0 13.999-7.496 13.999-13.986 0-.209 0-.42-.015-.63a9.936 9.936 0 0 0 2.46-2.548l-.047-.02z"/>
      </symbol>
      <symbol id="linkedin" viewBox="0 0 24 24">
        <path d="M20.447 20.452h-3.554v-5.569c0-1.328-.027-3.037-1.852-3.037-1.853 0-2.136 1.445-2.136 2.939v5.667H9.351V9h3.414v1.561h.046c.477-.9 1.637-1.85 3.37-1.85 3.601 0 4.267 2.37 4.267 5.455v6.286zM5.337 7.433a2.062 2.062 0 0 1-2.063-2.065 2.064 2.064 0 1 1 2.063 2.065zm1.782 13.019H3.555V9h3.564v11.452zM22.225 0H1.771C.792 0 0 .774 0 1.729v20.542C0 23.227.792 24 1.771 24h20.451c.979 0 1.771-.773 1.771-1.729V1.729C24 .774 23.204 0 22.225 0z"/>
      </symbol>
      <symbol id="instagram" viewBox="0 0 24 24">
        <path d="M12 2.163c3.204 0 3.584.012 4.85.07 3.252.148 4.771 1.691 4.919 4.919.058 1.265.069 1.645.069 4.849 0 3.205-.012 3.584-.069 4.849-.149 3.225-1.664 4.771-4.919 4.919-1.266.058-1.644.07-4.85.07-3.204 0-3.584-.012-4.849-.07-3.26-.149-4.771-1.699-4.919-4.92-.058-1.265-.07-1.644-.07-4.849 0-3.204.013-3.583.07-4.849.149-3.227 1.664-4.771 4.919-4.919 1.266-.057 1.645-.069 4.849-.069zM12 0C8.741 0 8.333.014 7.053.072 2.695.272.273 2.69.073 7.052.014 8.333 0 8.741 0 12c0 3.259.014 3.668.072 4.948.2 4.358 2.618 6.78 6.98 6.98C8.333 23.986 8.741 24 12 24c3.259 0 3.668-.014 4.948-.072 4.354-.2 6.782-2.618 6.979-6.98.059-1.28.073-1.689.073-4.948 0-3.259-.014-3.667-.072-4.947-.196-4.354-2.617-6.78-6.979-6.98C15.668.014 15.259 0 12 0zm0 5.838a6.162 6.162 0 1 0 0 12.324 6.162 6.162 0 0 0 0-12.324zM12 16a4 4 0 1 1 0-8 4 4 0 0 1 0 8zm4.965-10.405a1.44 1.44 0 1 1 2.881.001 1.44 1.44 0 0 1-2.881-.001z"/>
      </symbol>
      <symbol id="youtube" viewBox="0 0 24 24">
        <path d="M23.498 6.186a3.016 3.016 0 0 0-2.122-2.136C19.505 3.545 12 3.545 12 3.545s-7.505 0-9.377.505A3.017 3.017 0 0 0 .502 6.186C0 8.07 0 12 0 12s0 3.93.502 5.814a3.016 3.016 0 0 0 2.122 2.136c1.871.505 9.376.505 9.376.505s7.505 0 9.377-.505a3.015 3.015 0 0 0 2.122-2.136C24 15.93 24 12 24 12s0-3.93-.502-5.814zM9.545 15.568V8.432L15.818 12l-6.273 3.568z"/>
      </symbol>
    </svg>
  );

  // Vegetable products data
  const vegetables = [
    {
      id: 1,
      name: 'Fresh Ginger',
      category: 'herbs',
      pack: '200g pack',
      description: 'Spicy & Aromatic',
      price: 137,
      originalPrice: 150,
      image: gingerImg,
      rating: 5,
      reviews: 156,
      badge: 'herb',
      seasonal: false
    },
    {
      id: 2,
      name: 'Fresh Thyme',
      category: 'herbs',
      pack: '50g bunch',
      description: 'Earthy & Floral',
      price: 500,
      originalPrice: 600,
      image: thymeImg,
      rating: 4.5,
      reviews: 98,
      badge: 'herb',
      seasonal: false
    }
  ];

  // Filtered vegetables based on active filter
  const filteredVegetables = activeFilter === 'all' 
    ? vegetables 
    : vegetables.filter(veg => veg.category === activeFilter);

  const handleAddToCart = (productName) => {
    // Simple animation
    const button = document.querySelector(`.add-to-cart-${productName.replace(/\s+/g, '-').toLowerCase()}`);
    if (button) {
      button.style.transform = 'scale(0.95)';
      setTimeout(() => {
        button.style.transform = 'scale(1)';
      }, 100);
    }
    alert(`${productName} added to cart!`);
  };

  // Add all the CSS styles
  const styles = `
    :root {
      --fresh-green: #4CAF50;
      --fresh-green-dark: #388E3C;
      --fresh-orange: #FF9800;
      --fresh-yellow: #FFC107;
      --fresh-red: #F44336;
      --fresh-purple: #9C27B0;
      --fresh-brown: #8B4513;
      --bg-light: #F8F9FA;
    }

    /* Preloader Styles */
    .preloader {
      position: fixed;
      top: 0;
      left: 0;
      width: 100%;
      height: 100%;
      background: #fff;
      z-index: 9999;
      display: flex;
      justify-content: center;
      align-items: center;
      transition: opacity 0.5s ease, visibility 0.5s ease;
    }

    .loader {
      width: 48px;
      height: 48px;
      border: 5px solid var(--fresh-green);
      border-bottom-color: transparent;
      border-radius: 50%;
      display: inline-block;
      box-sizing: border-box;
      animation: rotation 1s linear infinite;
    }

    @keyframes rotation {
      0% { transform: rotate(0deg); }
      100% { transform: rotate(360deg); }
    }

    /* Page Header */
    #page-header {
      min-height: 400px;
      display: flex;
      align-items: center;
    }

    /* Product Card Styles */
    .product-card {
      transition: all 0.3s ease;
      border: 1px solid #eee;
      border-radius: 15px;
      overflow: hidden;
      background: white;
      height: 100%;
    }
    
    .product-card:hover {
      transform: translateY(-5px);
      box-shadow: 0 10px 30px rgba(0,0,0,0.1);
    }
    
    .category-badge {
      background: var(--fresh-green);
      color: white;
      padding: 5px 15px;
      border-radius: 25px;
      font-size: 14px;
    }
    
    .price-tag {
      color: var(--fresh-green-dark);
      font-weight: bold;
      font-size: 1.4rem;
    }
    
    .add-to-cart {
      background: var(--fresh-green);
      color: white;
      border: none;
      padding: 10px 20px;
      border-radius: 25px;
      transition: all 0.3s;
      width: 100%;
    }
    
    .add-to-cart:hover {
      background: var(--fresh-green-dark);
    }
    
    .organic-badge {
      background: var(--fresh-orange);
      color: white;
      padding: 3px 10px;
      border-radius: 15px;
      font-size: 12px;
      position: absolute;
      top: 10px;
      right: 10px;
      z-index: 10;
    }

    .herb-badge {
      background: var(--fresh-brown);
      color: white;
      padding: 3px 10px;
      border-radius: 15px;
      font-size: 12px;
      position: absolute;
      top: 10px;
      left: 10px;
      z-index: 10;
    }
    
    .btn-primary {
      background-color: var(--fresh-green) !important;
      border-color: var(--fresh-green) !important;
    }
    
    .btn-primary:hover {
      background-color: var(--fresh-green-dark) !important;
      border-color: var(--fresh-green-dark) !important;
      transform: translateY(-2px);
      box-shadow: 0 5px 15px rgba(76, 175, 80, 0.3);
    }
    
    .text-primary {
      color: var(--fresh-green) !important;
    }

    /* Filter Button Styles */
    .filter-btn {
      border: 1px solid #ddd;
      border-radius: 30px;
      padding: 8px 20px;
      margin: 0 5px 10px;
      background: white;
      transition: all 0.3s;
      cursor: pointer;
    }

    .filter-btn:hover,
    .filter-btn.active {
      background: var(--fresh-green);
      color: white;
      border-color: var(--fresh-green);
    }

    /* Vegetable Banner */
    .vegetable-banner {
      background: linear-gradient(135deg, #f8f9fa 0%, #e9ecef 100%);
      border-radius: 20px;
      padding: 40px;
    }

    /* Nutrition Card */
    .nutrition-card {
      background: white;
      border-radius: 15px;
      padding: 20px;
      text-align: center;
      box-shadow: 0 5px 15px rgba(0, 0, 0, 0.05);
      transition: all 0.3s ease;
    }

    .nutrition-card:hover {
      transform: translateY(-5px);
      box-shadow: 0 10px 30px rgba(0, 0, 0, 0.1);
    }

    .nutrition-icon {
      font-size: 2rem;
      color: var(--fresh-green);
      margin-bottom: 10px;
    }

    /* Rating Stars */
    .rating {
      color: #ffc107;
    }

    /* Button Arrow Effect */
    .btn-arrow {
      position: relative;
      overflow: hidden;
      transition: all 0.3s ease;
    }

    .btn-arrow i {
      transition: transform 0.3s ease;
    }

    .btn-arrow:hover i {
      transform: translateX(5px);
    }

    /* Social Icons Hover */
    .social-links .social {
      transition: transform 0.3s ease;
    }

    .social-links .social:hover {
      transform: translateY(-3px);
    }

    .social-links svg {
      fill: #666;
      transition: fill 0.3s ease;
    }

    .social-links .social:hover svg {
      fill: var(--fresh-green);
    }

    /* Navbar Styles */
    #primary-header {
      background: white;
      box-shadow: 0 2px 10px rgba(0,0,0,0.05);
    }

    .navbar-nav .nav-link {
      position: relative;
      padding: 5px 0 !important;
    }

    .navbar-nav .nav-link::after {
      content: '';
      position: absolute;
      bottom: 0;
      left: 0;
      width: 0;
      height: 2px;
      background: var(--fresh-green);
      transition: width 0.3s ease;
    }

    .navbar-nav .nav-link:hover::after,
    .navbar-nav .nav-link.active::after {
      width: 100%;
    }

    /* Dropdown Menu Animation */
    .dropdown-menu {
      display: block;
      opacity: 0;
      visibility: hidden;
      transform: translateY(10px);
      transition: all 0.3s ease;
    }

    .dropdown:hover .dropdown-menu {
      opacity: 1;
      visibility: visible;
      transform: translateY(0);
    }

    .dropdown-item {
      transition: all 0.3s ease;
    }

    .dropdown-item:hover {
      background: var(--fresh-green);
      color: white !important;
      padding-left: 20px;
    }

    /* Logo Animation */
    .logo {
      transition: transform 0.3s ease;
    }

    .logo:hover {
      transform: scale(1.05);
    }

    /* Responsive Styles */
    @media (max-width: 768px) {
      .padding-side {
        padding-left: 1rem;
        padding-right: 1rem;
      }
      
      .display-1 {
        font-size: 3rem;
      }
      
      .display-2 {
        font-size: 2.5rem;
      }
      
      .display-3 {
        font-size: 2rem;
      }

      .vegetable-banner {
        padding: 20px;
      }
    }

    /* Utility Classes */
    .padding-side {
      padding-left: 3rem;
      padding-right: 3rem;
    }

    .padding-large {
      padding: 5rem 0;
    }

    .padding-medium {
      padding: 4rem 0;
    }

    .padding-small {
      padding: 2rem 0;
    }

    .bg-light {
      background-color: #f8f9fa !important;
    }
  `;

  return (
    <div className="vegetables-page">
      {/* Inject Styles */}
      <style>{styles}</style>

      {/* SVG Sprites */}
      {socialIcons}

      {/* Preloader */}
      <div className="preloader">
        <div className="loader"></div>
      </div>

      {/* Header */}
      <header id="header">
        <nav className="header-top py-1" style={{ backgroundColor: '#f8f9fa', borderBottom: '1px solid #eee' }}>
          <div className="container-fluid padding-side">
            <div className="d-flex flex-wrap justify-content-between align-items-center">
              <ul className="info d-flex flex-wrap list-unstyled m-0">
                <li className="location text-capitalize d-flex align-items-center me-4" style={{ fontSize: '14px', color: '#666' }}>
                  <i className="fa fa-map-marker-alt" style={{ color: '#388E3C', marginRight: '5px' }}></i> HD Kote Taluk, Karapura, Around Mysore - 571 114
                </li>
                <li className="phone d-flex align-items-center me-4" style={{ fontSize: '14px', color: '#666' }}>
                  <i className="fa fa-phone" style={{ color: '#388E3C', marginRight: '5px' }}></i>9886228154
                </li>
                <li className="time d-flex align-items-center me-4" style={{ fontSize: '14px', color: '#666' }}>
                  <i className="fa fa-envelope" style={{ color: '#388E3C', marginRight: '5px' }}></i>Info@kabinee.com
                </li>
              </ul>
              <ul className="social-links d-flex flex-wrap list-unstyled m-0">
                <li className="social">
                  <a href="#">
                    <svg className="social" width="16" height="16">
                      <use xlinkHref="#facebook"></use>
                    </svg>
                  </a>
                </li>
                <li className="social ms-4">
                  <a href="#">
                    <svg className="social" width="16" height="16">
                      <use xlinkHref="#twitter"></use>
                    </svg>
                  </a>
                </li>
                <li className="social ms-4">
                  <a href="#">
                    <svg className="social" width="16" height="16">
                      <use xlinkHref="#linkedin"></use>
                    </svg>
                  </a>
                </li>
                <li className="social ms-4">
                  <a href="#">
                    <svg className="social" width="16" height="16">
                      <use xlinkHref="#instagram"></use>
                    </svg>
                  </a>
                </li>
                <li className="social ms-4">
                  <a href="#">
                    <svg className="social" width="16" height="16">
                      <use xlinkHref="#youtube"></use>
                    </svg>
                  </a>
                </li>
              </ul>
            </div>
          </div>
        </nav>

        <nav id="primary-header" className="navbar navbar-expand-lg py-4">
          <div className="container-fluid padding-side">
            <div className="d-flex justify-content-between align-items-center w-100">
              <Link className="navbar-brand" to="/">
                <img src={kabiniLogo} className="logo img-fluid" style={{ width: '18%' }} alt="Kabini Logo" />
              </Link>

              {/* Navbar Toggler Button */}
              <button className="navbar-toggler border-0 d-flex d-lg-none order-3 p-2 shadow-none" type="button"
                data-bs-toggle="offcanvas" data-bs-target="#bdNavbar" 
                aria-controls="bdNavbar" aria-expanded="false">
                <svg className="navbar-icon" width="40" height="40" style={{ color: '#000000', fill: 'currentColor' }}>
                  <rect x="10" y="12" width="20" height="2" fill="currentColor"/>
                  <rect x="10" y="22" width="20" height="2" fill="currentColor"/>
                  <rect x="10" y="32" width="20" height="2" fill="currentColor"/>
                </svg>
              </button>

              <div className="header-bottom offcanvas offcanvas-end" id="bdNavbar" aria-labelledby="bdNavbarOffcanvasLabel">
                <div className="offcanvas-header px-4 pb-0">
                  <h5 className="offcanvas-title" id="bdNavbarOffcanvasLabel">Menu</h5>
                  <button type="button" className="btn-close btn-close-black" data-bs-dismiss="offcanvas" aria-label="Close"></button>
                </div>
                <div className="offcanvas-body align-items-center justify-content-center">
                  <div className="search d-block d-lg-none m-4"></div>
                  <ul className="navbar-nav align-items-center mb-2 mb-lg-0">
                    <li className="nav-item px-3">
                      <Link className="nav-link p-0 fw-bold" to="/">Home</Link>
                    </li>
                    <li className="nav-item px-3">
                      <Link className="nav-link p-0 fw-bold" to="/about">About</Link>
                    </li>
                    <li className="nav-item px-3 dropdown">
                      <Link className="nav-link p-0 dropdown-toggle fw-bold" data-bs-toggle="dropdown" to="#" role="button" aria-expanded="false">Products</Link>
                      <ul className="dropdown-menu dropdown-menu-end animate slide mt-3 border-0 shadow">
                        {/* <li><Link to="/fruits" className="dropdown-item fw-bold">Fruits</Link></li> */}
                        <li><Link to="/vegetables" className="dropdown-item fw-bold">Vegetables</Link></li>
                        <li><Link to="/spices" className="dropdown-item fw-bold">Spices</Link></li>
                      </ul>
                    </li>
                    <li className="nav-item px-3">
                      <Link className="nav-link p-0 fw-bold" to="/contact">Contact</Link>
                    </li>
                  </ul>
                </div>
              </div>
            </div>
          </div>
        </nav>
      </header>

      {/* Page Header */}
      <section
        id="page-header"
        className="padding-large"
        style={{
          background: "linear-gradient(rgba(0, 0, 0, 0.5), rgba(0, 0, 0, 0.5)), url('https://images.unsplash.com/photo-1566385101042-1a0aa0c1268c?ixlib=rb-4.0.3&auto=format&fit=crop&w=1920&q=80')",
          backgroundSize: 'cover',
          backgroundPosition: 'center',
          minHeight: '400px',
          display: 'flex',
          alignItems: 'center'
        }}
      >
        <div className="container-fluid padding-side text-center text-white">
          <h1 className="display-1 fw-normal text-white">Fresh Organic Vegetables</h1>
        </div>
      </section>

      {/* Vegetable Categories Banner */}
      <section id="categories" className="padding-medium pt-5">
        <div className="container-fluid padding-side">
          <div className="vegetable-banner">
            <div className="row align-items-center">
              <div className="col-lg-6">
                <h3 className="display-4 fw-normal">Farm Fresh Goodness</h3>
                <p className="lead">
                  Our vegetables are harvested at peak freshness, ensuring maximum
                  flavor and nutrition. From leafy greens to root vegetables, 
                  we bring the garden to your kitchen.
                </p>
                <div className="d-flex flex-wrap mt-4">
                  <div className="me-4 mb-2">
                    <i className="fas fa-check-circle text-primary"></i>
                    <span className="ms-2">100% Organic</span>
                  </div>
                  <div className="me-4 mb-2">
                    <i className="fas fa-check-circle text-primary"></i>
                    <span className="ms-2">Farm Fresh</span>
                  </div>
                  <div className="me-4 mb-2">
                    <i className="fas fa-check-circle text-primary"></i>
                    <span className="ms-2">No Pesticides</span>
                  </div>
                </div>
              </div>
              <div className="col-lg-6 mt-4 mt-lg-0">
                <div className="row text-center">
                  <div className="col-4">
                    <div className="nutrition-card">
                      <i className="fas fa-carrot nutrition-icon"></i>
                      <h5>20+</h5>
                      <p className="small mb-0">Vegetable Varieties</p>
                    </div>
                  </div>
                  <div className="col-4">
                    <div className="nutrition-card">
                      <i className="fas fa-leaf nutrition-icon"></i>
                      <h5>100%</h5>
                      <p className="small mb-0">Organic</p>
                    </div>
                  </div>
                  <div className="col-4">
                    <div className="nutrition-card">
                      <i className="fas fa-truck nutrition-icon"></i>
                      <h5>24hr</h5>
                      <p className="small mb-0">Farm to Door</p>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Filter Buttons */}
      <section className="pt-3">
        <div className="container-fluid padding-side">
          <div className="d-flex flex-wrap justify-content-center">
            <button 
              className={`filter-btn ${activeFilter === 'all' ? 'active' : ''}`}
              onClick={() => filterVegetables('all')}
            >
              All Vegetables
            </button>
            <button 
              className={`filter-btn ${activeFilter === 'herbs' ? 'active' : ''}`}
              onClick={() => filterVegetables('herbs')}
            >
              Herbs
            </button>
            <button 
              className={`filter-btn ${activeFilter === 'leafy' ? 'active' : ''}`}
              onClick={() => filterVegetables('leafy')}
            >
              Leafy Greens
            </button>
            <button 
              className={`filter-btn ${activeFilter === 'root' ? 'active' : ''}`}
              onClick={() => filterVegetables('root')}
            >
              Root Vegetables
            </button>
          </div>
        </div>
      </section>

      {/* Vegetables Grid */}
      <section id="vegetables-grid" className="padding-small">
        <div className="container-fluid padding-side">
          <div className="row">
            {/* Vegetables & Herbs Category */}
            <div className="col-12 mb-4">
              <h3 className="display-6 fw-normal">
                <i className="fas fa-chevron-circle-right text-primary me-2"></i>
                Fresh Vegetables & Herbs
              </h3>
            </div>

            {/* Map through filtered vegetables */}
            {filteredVegetables.map((veg) => (
              <div
                key={veg.id}
                className="col-md-6 col-lg-3 mb-4 vegetable-item"
                data-category={veg.category}
              >
                <div className="product-card position-relative">
                  <span className="organic-badge">Organic</span>
                  {veg.badge === 'herb' && <span className="herb-badge">Herb</span>}
                  <img
                    src={veg.image}
                    alt={veg.name}
                    className="img-fluid w-100"
                    style={{ height: '200px', objectFit: 'cover' }}
                  />
                  <div className="product-content p-3">
                    <div className="rating mb-2">
                      {[...Array(5)].map((_, i) => {
                        if (i < Math.floor(veg.rating)) {
                          return <i key={i} className="fas fa-star"></i>;
                        } else if (i === Math.floor(veg.rating) && veg.rating % 1 !== 0) {
                          return <i key={i} className="fas fa-star-half-alt"></i>;
                        } else {
                          return <i key={i} className="far fa-star"></i>;
                        }
                      })}
                      <span className="ms-2 small">({veg.reviews})</span>
                    </div>
                    <h4 className="h5 fw-normal">{veg.name}</h4>
                    <p className="text-muted small">{veg.pack} · {veg.description}</p>
                    <div className="d-flex justify-content-between align-items-center">
                      <p className="price-tag mb-0">Rs.{veg.price}</p>
                      {veg.originalPrice && (
                        <p className="text-muted text-decoration-line-through small mb-0">
                          Rs.{veg.originalPrice}
                        </p>
                      )}
                    </div>
                    <button 
                      className={`add-to-cart mt-3 add-to-cart-${veg.name.replace(/\s+/g, '-').toLowerCase()}`}
                      onClick={() => handleAddToCart(veg.name)}
                    >
                      <i className="fas fa-shopping-cart me-2"></i>
                      Add to Cart
                    </button>
                  </div>
                </div>
              </div>
            ))}

            {/* If no vegetables found */}
            {filteredVegetables.length === 0 && (
              <div className="col-12 text-center py-5">
                <h4>No vegetables found in this category</h4>
              </div>
            )}
          </div>
        </div>
      </section>

      {/* Vegetable Nutrition Guide */}
      <section id="nutrition-guide" className="padding-medium bg-light">
        <div className="container-fluid padding-side" data-aos="fade-up">
          <div className="text-center mb-5">
            <h3 className="display-3 fw-normal">Vegetable Nutrition Guide</h3>
            <p className="lead col-lg-6 mx-auto">
              Nature's medicine cabinet - packed with essential vitamins and minerals
            </p>
          </div>

          <div className="row">
            <div className="col-md-3 col-6 mb-4 text-center">
              <div className="bg-white p-4 rounded-4">
                <i className="fas fa-heartbeat fa-3x" style={{ color: '#F44336' }}></i>
                <h5 className="mt-3">Heart Health</h5>
                <p className="small">Leafy greens, tomatoes</p>
              </div>
            </div>
            <div className="col-md-3 col-6 mb-4 text-center">
              <div className="bg-white p-4 rounded-4">
                <i className="fas fa-bone fa-3x" style={{ color: '#8B4513' }}></i>
                <h5 className="mt-3">Bone Strength</h5>
                <p className="small">Broccoli, kale</p>
              </div>
            </div>
            <div className="col-md-3 col-6 mb-4 text-center">
              <div className="bg-white p-4 rounded-4">
                <i className="fas fa-eye fa-3x" style={{ color: '#FF9800' }}></i>
                <h5 className="mt-3">Eye Health</h5>
                <p className="small">Carrots, spinach</p>
              </div>
            </div>
            <div className="col-md-3 col-6 mb-4 text-center">
              <div className="bg-white p-4 rounded-4">
                <i className="fas fa-shield-alt fa-3x" style={{ color: '#4CAF50' }}></i>
                <h5 className="mt-3">Immunity</h5>
                <p className="small">Bell peppers, ginger</p>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Call to Action */}
      <section
        id="cta"
        className="padding-medium"
        style={{
          background: "linear-gradient(rgba(0, 0, 0, 0.7), rgba(0, 0, 0, 0.7)), url('https://images.unsplash.com/photo-1550989460-0adf9ea622e2?ixlib=rb-4.0.3&auto=format&fit=crop&w=1920&q=80')",
          backgroundSize: 'cover',
          backgroundPosition: 'center',
          backgroundAttachment: 'fixed'
        }}
      >
        <div
          className="container-fluid padding-side text-center text-white"
          data-aos="fade-up"
        >
          <h3 className="display-2 fw-normal mb-4" style={{ color: 'white' }}>
            Fresh Vegetables Delivered to Your Door
          </h3>
          <p className="lead col-lg-6 mx-auto mb-5" style={{ color: 'white' }}>
            Order by 10 AM for same-day delivery in most areas
          </p>
          <Link
            to="/vegetables"
            className="btn btn-arrow btn-primary btn-lg px-5 py-3"
          >
            <span style={{ color: 'white' }}>
              Shop Vegetables <i className="fas fa-arrow-right ms-2"></i>
            </span>
          </Link>
        </div>
      </section>

      {/* Footer */}
      {/* <section id="footer">
        <hr className="text-black" />
        <div className="container-fluid padding-side padding-small" data-aos="fade-up">
          <footer className="row">
            <div className="col-md-6 col-lg-3 mb-4 mb-lg-0">
              <h4 className="display-6 fw-normal">Quick links</h4>
              <ul className="nav flex-column">
                <li className="nav-item mb-2">
                  <Link to="/" className="p-0 text-dark">Home</Link>
                </li>
                <li className="nav-item mb-2">
                  <Link to="/about" className="p-0 text-dark">About Us</Link>
                </li>
                <li className="nav-item mb-2">
                  <Link to="/vegetables" className="p-0 text-dark">Vegetables</Link>
                </li>
                <li className="nav-item mb-2">
                  <Link to="/fruits" className="p-0 text-dark">Fruits</Link>
                </li>
                <li className="nav-item mb-2">
                  <Link to="/spices" className="p-0 text-dark">Spices</Link>
                </li>
                <li className="nav-item mb-2">
                  <Link to="/contact" className="p-0 text-dark">Contact Us</Link>
                </li>
              </ul>
            </div>
            <div className="col-md-6 col-lg-3 offset-lg-1 mb-4 mb-lg-0"></div>
            <div className="col-md-6 col-lg-3 offset-lg-1 mb-4 mb-lg-0">
              <p className="m-0">© Copyright 2024 FreshHarvest.</p>
              <p>
                Farm Fresh Organic Vegetables & Fruits<br />
                Delivered with love from our family to yours
              </p>
            </div>
          </footer>
        </div>
      </section> */}
    </div>
  );
};

export default VegetablesPage;